import { environment, localization } from "@/lib/resources";
import $ from "jquery";

$(".cart-list__body")
	.find<HTMLInputElement>(".cart-list__amount input")
	.on("keyup", e => verfuegbarkeitPruefen(e.currentTarget))
	.on("change", e => verfuegbarkeitPruefen(e.currentTarget))
	.each((_, el) => verfuegbarkeitPruefen(el));

function verfuegbarkeitPruefen(target: HTMLInputElement) {
	let $lagerbestand = $(target)
		.closest("tr")
		.find(".cart-list__availability");

	$lagerbestand.removeClass("is-available");
	$lagerbestand.removeClass("is-demandable");

	let istProspekt = $(target).attr("data-prospekt-artikel");

	if (istProspekt === "True") {
		setLieferzeitProspekt($lagerbestand);
	} else {
		let gewaehlteMenge = parseInt($(target).val()!, 10);
		let lagerbestandMenge = parseInt($(target).attr("data-lagerbestand") as string, 10);
		let lagerbestandKurzfristigBeschaffbarMenge = parseInt($(target).attr("data-lagerbestand-kurzfristig-beschaffbar") as string, 10);
		let lagerbestandLangfristigBeschaffbarMenge = parseInt($(target).attr("data-lagerbestand-langfristig-beschaffbar") as string, 10);
		let lagerbestandInklusiveGanterLagerCanada = $(target).data("lagerbestand-inklusive-ganter-lager-canada") as number;

		if (environment.landKuerzel == "ca"
			&& gewaehlteMenge > lagerbestandMenge
			&& gewaehlteMenge <= lagerbestandInklusiveGanterLagerCanada) {

			setLagerbestandInklusiveGanterLagerCanada($lagerbestand, lagerbestandInklusiveGanterLagerCanada);
			return;
		}
		// Diese Logik liegt auch unter Ganter.Responsive.Entities.Lagerbestand.Lagerbestand.GetArtikelVerfuegbarkeit()
		// Wenn sich hier etwas ändert, muss das auf der Entity nachgezogen werden.
		let lagerSumme = lagerbestandMenge + lagerbestandKurzfristigBeschaffbarMenge;
		let lagerSummeMitDrittLager = lagerSumme + lagerbestandLangfristigBeschaffbarMenge;
		if (gewaehlteMenge < 1) {
			setPositionNichtLieferbar($lagerbestand, lagerbestandInklusiveGanterLagerCanada);
		} else if (gewaehlteMenge <= lagerbestandMenge) {
			setPositionLieferbar($lagerbestand, lagerbestandMenge);
		} else if (gewaehlteMenge <= lagerSumme) {
			setPositionKurzfristigBeschaffbar($lagerbestand);
		} else if (gewaehlteMenge <= lagerSummeMitDrittLager) {
			setPositionLangfristigBeschaffbar($lagerbestand);
		} else {
			setPositionNichtLieferbar($lagerbestand, lagerbestandInklusiveGanterLagerCanada);
		}
	}
}

function setPositionLieferbar(lagerbestandElement: JQuery<HTMLElement>, lagerbestand: number) {
	lagerbestandElement.html(getLagerbestandText("artikelLagerbestandVerfuegbar", lagerbestand));
	lagerbestandElement.addClass("is-available");
}

function setPositionKurzfristigBeschaffbar(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.html(localization("artikelLagerbestandKurzfristigBeschaffbar"));
	lagerbestandElement.addClass("is-available");
}

function setPositionLangfristigBeschaffbar(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.html(localization("artikelLagerbestandLangfristigBeschaffbar"));
	lagerbestandElement.addClass("is-available");
}

function setPositionNichtLieferbar(lagerbestandElement: JQuery<HTMLElement>, lagerbestand: number) {
	lagerbestandElement.html(getLagerbestandText("artikelLagerbestandAnfrage", lagerbestand));
	lagerbestandElement.addClass("is-demandable");
}

function setLieferzeitProspekt(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.addClass("is-available");
}

function setLagerbestandInklusiveGanterLagerCanada(lagerbestandElement: JQuery<HTMLElement>, lagerbestand: number) {
	lagerbestandElement.html(getLagerbestandText("artikelLagerbestandInklusiveGanterLager", lagerbestand));
	lagerbestandElement.addClass("is-available");
}

function getLagerbestandText(sprachCode: string, lagerbestand: number): string {
	if (lagerbestand < 1) {
		return localization("artikelLagerbestandAnfrageMengeNull");
	}

	return localization(sprachCode)
		.replace("{lagerbestand}", lagerbestand.toString());
}

